/**
 * Whitelist of IFCN-verified fact-checker publishers surfaced by
 * Google Fact Check Tools + a handful of major newsroom fact-check desks.
 * Used by the "Fact-checkers only" toggle to filter claim sources.
 */
export const FACT_CHECKER_DOMAINS = new Set([
  "snopes.com",
  "politifact.com",
  "factcheck.org",
  "fullfact.org",
  "apnews.com",
  "reuters.com",
  "usatoday.com",
  "washingtonpost.com",
  "bbc.com",
  "bbc.co.uk",
  "leadstories.com",
  "checkyourfact.com",
  "healthfeedback.org",
  "afp.com",
  "factcheck.afp.com",
  "logically.ai",
  "misbar.com",
  "boomlive.in",
  "altnews.in",
  "dpa-factchecking.com",
  "poynter.org",
]);

/** Return true if the given SourceEvidence should show under "Fact-checkers only" mode. */
export function isFactCheckerSource(source) {
  if (!source) return false;
  const d = String(source.domain || "").toLowerCase().replace(/^www\./, "");
  if (FACT_CHECKER_DOMAINS.has(d)) return true;
  // Also allow subdomains like factcheck.afp.com, factcheck.org.uk, etc.
  for (const known of FACT_CHECKER_DOMAINS) {
    if (d.endsWith(`.${known}`)) return true;
  }
  return false;
}
